import { render, staticRenderFns } from "./skeletonCircle.vue?vue&type=template&id=70b57b3a&scoped=true&"
import script from "./skeletonCircle.vue?vue&type=script&lang=js&"
export * from "./skeletonCircle.vue?vue&type=script&lang=js&"
import style0 from "./skeletonCircle.vue?vue&type=style&index=0&id=70b57b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b57b3a",
  null
  
)

export default component.exports